import styled from 'styled-components';

const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-family: Roboto Bold;
  font-style: normal;
  width: ${props => props.width};
  cursor: pointer;
  padding: 8px;
  font-weight: 600;
  color: ${props => props.color};
  background: ${props => props.bgColor};
  height: ${props => props.height};
  font-size: ${props => props.fontSize};
  border: ${props => props.borderWidth} solid ${props => props.borderColor};
  border-radius: ${props => props.borderRadius};

  * {
    cursor: pointer;
  }
  &:active {
    opacity: 0.8;
  }
  svg {
    margin-right: 8px;
  }

  label {
    margin: 0px auto;
    font-weight: 400;
    color: ${props => props.color};
    font-size: ${props => props.fontSize};
  }

  &.primary {
    background: ${({ theme }) => theme.colors.zenPurple};
    border: 1px solid ${({ theme }) => theme.colors.zenPurple};
    width: 100%;

    label {
      color: #ffffff;
    }
  }

  &.secondary {
    background: ${({ theme }) => theme.colors.ZenDefaultSecondary};
    border: 1px solid ${({ theme }) => theme.colors.ZenDefaultSecondary};
    width: 100%;

    label {
      color: #ffffff;
    }
  }

  &.negative {
    background: ${({ theme }) => theme.colors.ZenNegative};
    border: 1px solid ${({ theme }) => theme.colors.ZenNegative};
    width: 100%;

    label {
      color: #ffffff;
    }
    &.disabled {
      opacity: 0.3;
      background: ${({ theme }) => theme.colors.ZenNegative};
      border: 1px solid ${({ theme }) => theme.colors.ZenNegative};
      label {
        color: #ffffff;
      }
    }
  }

  &.primary-white {
    background: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.zenPurple};

    label {
      color: ${({ theme }) => theme.colors.zenPurple};
    }
    &.disabled {
      opacity: 0.3;
      background: #ffffff;
      border: 1px solid ${({ theme }) => theme.colors.zenPurple};
      label {
        color: ${({ theme }) => theme.colors.zenPurple};
      }
    }
  }

  &.default-secondary {
    background: ${({ theme }) => theme.colors.ZenPurpleSecondary2};
    border: 1px solid ${({ theme }) => theme.colors.ZenPurpleSecondary2};

    label {
      color: ${({ theme }) => theme.colors.zenPurple};
    }

    &:hover {
      background: ${({ theme }) => theme.colors.ZenTransparent} !important;
      border: 1px solid ${({ theme }) => theme.colors.ZenGray2} !important;
    }
    &:active {
      background: ${({ theme }) => theme.colors.ZenPurple3} !important;
      border: 1px solid ${({ theme }) => theme.colors.ZenGray2} !important;
    }
  }

  &.background-primary {
    background: ${({ theme }) => theme.colors.backgroundColor};
    border: 1px dashed ${({ theme }) => theme.colors.zenPurple};

    label {
      color: ${({ theme }) => theme.colors.zenPurple};
    }
  }

  &.primary-grey {
    background: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.ZenGray2};

    label {
      color: ${({ theme }) => theme.colors.RegularText};
    }
  }

  &.disabled {
    background: ${({ theme }) => theme.colors.ZenDefaultSecondary};
    border: 1px solid ${({ theme }) => theme.colors.ZenDefaultSecondary};

    label {
      color: #ffffff;
    }

    svg {
      * {
        stroke: #ffffff;
      }
    }

    &:hover {
      background: ${({ theme }) => theme.colors.ZenDefaultSecondary} !important;
      border: 1px solid ${({ theme }) => theme.colors.ZenDefaultSecondary} !important;
    }
    &:active {
      background: ${({ theme }) => theme.colors.ZenDefaultSecondary} !important;
      border: 1px solid ${({ theme }) => theme.colors.ZenDefaultSecondary} !important;
    }
  }

  &.specified-width {
    width: ${({ width }) => width};
  }
`;

export default ButtonWrapper;
